
export default function Venue() {
  return (
    <section id="venue" className="py-32 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-5xl md:text-6xl font-light mb-8 tracking-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
              Puerto Plata
            </h2>
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              A destination where ocean meets architecture. Where light transforms throughout the day. Where Caribbean heritage informs contemporary vision.
            </p>
            <p className="text-gray-600 leading-relaxed mb-6">
              Puerto Plata offers more than a backdrop—it provides context. The city's colonial elegance, coastal energy, and creative community create the ideal environment for this fashion moment.
            </p>
            <p className="text-gray-600 leading-relaxed mb-8">
              Our venue sits at the intersection of history and modernity, designed to showcase fashion in dialogue with place.
            </p>
            
            <div className="space-y-4">
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center">
                  <i className="ri-map-pin-line text-2xl text-[#14B8A6]"></i>
                </div>
                <div>
                  <h4 className="font-light text-lg mb-1">Location</h4>
                  <p className="text-gray-600 text-sm">Malecón de Puerto Plata, Dominican Republic</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center">
                  <i className="ri-calendar-line text-2xl text-[#14B8A6]"></i>
                </div>
                <div>
                  <h4 className="font-light text-lg mb-1">Dates</h4>
                  <p className="text-gray-600 text-sm">March 15-17, 2025</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 flex items-center justify-center">
                  <i className="ri-time-line text-2xl text-[#14B8A6]"></i>
                </div>
                <div>
                  <h4 className="font-light text-lg mb-1">Access</h4>
                  <p className="text-gray-600 text-sm">International airport 15 minutes from venue</p>
                </div>
              </div>
            </div>
          </div>

          <div className="space-y-6">
            <div className="relative overflow-hidden aspect-[4/5]">
              <img 
                src="https://public.readdy.ai/ai/img_res/ade08728a789d6cc9b3fd4527dcdb615.jpg"
                alt="Venue exterior"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="grid grid-cols-2 gap-6">
              <div className="relative overflow-hidden aspect-square">
                <img 
                  src="https://readdy.ai/api/search-image?query=Luxurious%20interior%20of%20modern%20fashion%20venue%20with%20high%20ceilings%20and%20elegant%20white%20runway%20setup%2C%20sophisticated%20lighting%20design%2C%20minimalist%20contemporary%20architecture%20with%20subtle%20tropical%20influences%2C%20professional%20event%20photography%2C%20premium%20fashion%20show%20space%20with%20clean%20aesthetic&width=600&height=600&seq=venue-interior-001&orientation=squarish"
                  alt="Venue interior"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="relative overflow-hidden aspect-square">
                <img 
                  src="https://readdy.ai/api/search-image?query=Stunning%20aerial%20view%20of%20Puerto%20Plata%20coastline%20with%20turquoise%20Caribbean%20waters%20and%20elegant%20colonial%20architecture%2C%20golden%20hour%20lighting%2C%20sophisticated%20coastal%20cityscape%2C%20professional%20travel%20photography%2C%20modern%20Caribbean%20destination%20with%20historic%20charm%20and%20ocean%20views&width=600&height=600&seq=venue-location-001&orientation=squarish"
                  alt="Puerto Plata"
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
